
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class LevelReportDialog extends Serenity.EntityDialog<LevelReportRow, any> {
        protected getFormKey() { return LevelReportForm.formKey; }
        protected getIdProperty() { return LevelReportRow.idProperty; }
        protected getLocalTextPrefix() { return LevelReportRow.localTextPrefix; }
        protected getNameProperty() { return LevelReportRow.nameProperty; }
        protected getService() { return LevelReportService.baseUrl; }
        protected getDeletePermission() { return LevelReportRow.deletePermission; }
        protected getInsertPermission() { return LevelReportRow.insertPermission; }
        protected getUpdatePermission() { return LevelReportRow.updatePermission; }

        protected form = new LevelReportForm(this.idPrefix);

    }
}